var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    zoomAndPan: "magnify",
    viewBox: "0 0 52.5 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "890509ecd5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.058594 1.546875 L 41 1.546875 L 41 50.578125 L 9.058594 50.578125 Z M 9.058594 1.546875 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#890509ecd5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M 30.976562 35.816406 L 37.890625 25.054688 C 40.941406 20.308594 41.148438 14.519531 38.4375 9.570312 C 35.730469 4.617188 30.75 1.660156 25.105469 1.660156 C 19.460938 1.660156 14.480469 4.617188 11.773438 9.570312 C 9.066406 14.511719 9.269531 20.300781 12.320312 25.054688 L 19.226562 35.808594 C 13.171875 36.882812 9.316406 39.574219 9.316406 42.820312 C 9.324219 47.171875 15.957031 50.335938 25.105469 50.335938 C 34.253906 50.335938 40.886719 47.171875 40.886719 42.820312 C 40.886719 39.558594 37.039062 36.875 30.976562 35.816406 Z M 31.664062 15.996094 C 31.664062 19.601562 28.71875 22.535156 25.105469 22.535156 C 21.492188 22.535156 18.550781 19.601562 18.550781 15.996094 C 18.550781 12.382812 21.492188 9.441406 25.105469 9.441406 C 28.71875 9.441406 31.664062 12.375 31.664062 15.996094 Z M 24.027344 43.277344 C 24.261719 43.652344 24.664062 43.871094 25.105469 43.871094 C 25.554688 43.871094 25.957031 43.652344 26.1875 43.285156 L 28.785156 39.230469 C 34.386719 39.894531 37.191406 41.886719 37.191406 42.820312 C 37.191406 43.960938 33.078125 46.640625 25.105469 46.640625 C 17.136719 46.640625 13.019531 43.960938 13.019531 42.820312 C 13.019531 41.886719 15.828125 39.902344 21.425781 39.230469 Z M 24.027344 43.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.925b42db238c50fa239b62512e2fd8ef.svg";
export { ForwardRef as ReactComponent };